import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import {makeAutoObservable, observable} from "mobx";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {INavigationRoute} from "data/types/navigation";
import type {IModalsStore} from "data/stores/modals/modals.store";
import {ModalType} from "data/enums";

export interface IHeaderController extends ViewController {
	readonly i18n: ILocalizationStore;

	get routes(): INavigationRoute[];

	menuState: boolean;
	toggleMenu: () => void;
	showModal: () => void;
}

@injectable()
export class HeaderController implements IHeaderController {
	@observable menuState = false;

	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	toggleMenu = () => (this.menuState = !this.menuState);

	get routes(): INavigationRoute[] {
		return [
			{
				path: "/play",
				label: "Play",
			},
			{
				path: "/apps/spinball/official-rules",
				label: "Official Rules",
				external: true,
			},
			{
				path: "/leagues",
				label: "Leagues",
			},
			{
				path: "/head_to_head/games",
				label: "H2H",
			},
			{
				path: "#",
				label: "Scoring",
				onClick: this.openScoringModal,
			},
		];
	}

	private openScoringModal = () => {
		this._modalsStore.showModal(ModalType.SCORING);
	};

	showModal = () => {
		this._modalsStore.showModal(ModalType.TUTORIAL);
	};
}
